import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { mapSelectValue } from '../../../utils'
import { usePersonalStore } from '../../../stores/personalInfo'
import moment from 'moment'
import Toast from 'react-native-toast-message'
import { useStoreStore } from '../../../stores/storeInfo'


const Form8850InformationForm = ({ navigation, route }): JSX.Element => {
    const formikRef = useRef(null)
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const options2 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]

    const options1 = [
        {
            key: 1,
            value:
                'I am a member of a family that has received assistance from Temporary Assistance for Needy Families (TANF) for any 9 months during the past 18 months'
        },
        {
            key: 2,
            value:
                'I am a veteran and a member of a family that received Supplemental Nutrition Assistance Program (SNAP) benefits (foodstamps) for at least a 3-month period during the past 15 months'
        },
        {
            key: 3,
            value:
                'I was referred here by a rehabilitation agency approved by the state, an employment network under the Ticket to Work program, or the Department of Veterans Affairs'
        },
        {
            key: 4,
            value: `I am at least age 18 but not age 40 or older and I am a member of a family that:
a.Received SNAP benefits(food stamps) for the past 6 months; or
b.Received SNAP benefits(food stamps) for at least 3 of the past 5 months, but is no longer eligible to receive them`
        },
        {
            key: 5,
            value: "During the past year, I was convicted of a felony or released from prison for a felony"
        },
        {
            key: 6,
            value: " I received supplemental security income (SSI) benefits for any month ending during the past 60 days"
        },
        {
            key: 7,
            value: "I am a veteran and I was unemployed for a period or periods totaling at least 4 weeks but less than 6 months during the past year"
        },
        {
            key: 8,
            value: "None"
        }
    ]

    const options3 = [
        {
            key: 1,
            value: "Received TANF payments for at least the past 18 months"

        },
        {
            key: 2,
            value: "Received TANF payments for any 18 months beginning after August 5, 1997, and the earliest 18-month period beginning after August 5, 1997, ended during the past 2 years"
        },
        {
            key: 3,
            value: "Stopped being eligible for TANF payments during the past 2 years because federal or state law limited the maximum time those payments could be made"
        },
        {
            key: 4,
            value: "None"
        }
    ]

    const intialValues = {
        county: "",
        age: "",
        receivedconditionalcertificate: "",
        is_qualified: "",
        is_veteran_unemployed_6_months: "",
        is_veteran_disability_discharged_past_year: "",
        is_veteran_disability_unemployed_6_months: "",
        is_family_tanf_eligible: "",
        is_unemployed_27_weeks: ""
    }
    const alschema = yup.object({
        county: yup.string().required("County is a required field"),
        age: yup.string().required("Age is a required field"),
        receivedconditionalcertificate: yup.string().required("Recevied conditional certificate is a required field"),
        is_qualified: yup.string().required("Qualified for exemption is a required field"),
        is_veteran_unemployed_6_months: yup.string().required("Is veteran unemployeed is a required field"),
        is_veteran_disability_discharged_past_year: yup.string().required("Released from active duty in the U.S. Armed Forces is a required field"),
        is_veteran_disability_unemployed_6_months: yup.string().required("Unemployed for a period is a required field"),
        is_family_tanf_eligible: yup.string().required("Is family tanf eligible is a required field"),
        is_unemployed_27_weeks: yup.string().required("Unemployed for period of 27 consecutive weeks is a required field")

    })

    const { loading, post8850online, getmodetails } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const { fetchData } = useStoreStore()

    useEffect(() => {
        getmodetails(initializestore?.initializeData?.userkey)
        fetchData(userId)
    }, [])



    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'Form 8850 Witholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={alschema}
                    onSubmit={async (values, actions) => {

                        if (mode === 'upload') {

                            const data = {
                                entityId: personalstore?.personalData?.entityId,
                                essUserKey: initializestore.initializeData.userkey,
                                essObKey: essUserOnBoardingKey,
                                essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                                completeOnline: false,
                                age: values?.age,
                                recievedconditionalcertificate: values?.receivedconditionalcertificate,
                                isQualified: values?.is_qualified,
                                isVeteranUnemployed6Months: values?.is_veteran_unemployed_6_months,
                                isVeteranDisabilityDischargedPastYear: values?.is_veteran_disability_discharged_past_year,
                                isVeteranDisabilityUnemployed6Months: values?.is_veteran_disability_unemployed_6_months,
                                isFamilyTanfEligible: values?.is_family_tanf_eligible,
                                isUnemployed27Weeks: values?.is_unemployed_27_weeks,
                                county: values?.county
                            }

                            const response = await post8850online(data)
                            if (response?.success) {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            } else {
                                await Toast.show({
                                    type: 'error',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60
                                })
                            }
                        } else {
                            navigation.navigate('Form8850InformationOnline', {
                                userId,
                                mode,
                                essUserOnBoardingKey,
                                essUserOnBoardingFormKey,
                                values,
                            })
                        }
                    }}
                >
                    {(props) => (
                        <>
                            <Card>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'County of Residence *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.county}
                                            onChangeText={(text) => {
                                                props.handleChange('county')(text)
                                            }}
                                        />
                                        {props.touched.county && props.errors.county && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.county}
                                            </Text>
                                        )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you under age 40? *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title={"Are you under age 40?"}
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.age
                                            )}
                                            onSelect={(option: any) => {

                                                props.setFieldValue('age', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.age &&
                                            props.errors.age && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.age as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Have you received a conditional certification from the state workforce agency (SWA) or a participating local agency for the Work Opportunity Credit? *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Have you received a conditional certification from the state workforce agency (SWA) or a participating local agency for the Work Opportunity Credit?"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.receivedconditionalcertificate
                                            )}
                                            onSelect={(option: any) => {

                                                props.setFieldValue('receivedconditionalcertificate', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.receivedconditionalcertificate &&
                                            props.errors.receivedconditionalcertificate && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.receivedconditionalcertificate as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Select any of the following statements apply to you *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Select any of the following statements apply to you"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.is_qualified
                                            )}
                                            onSelect={(option: any) => {
                                                if (option == 8) {
                                                    props.setFieldValue('is_qualified', 0)
                                                }
                                                else {
                                                    props.setFieldValue('is_qualified', 1)
                                                }
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.is_qualified &&
                                            props.errors.is_qualified && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.is_qualified as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you a veteran who has been unemployed for a total of at least 6 months during the past year?*'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Are you a veteran who has been unemployed for a total of at least 6 months during the past year?"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.is_veteran_unemployed_6_months
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('is_veteran_unemployed_6_months', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.is_veteran_unemployed_6_months &&
                                            props.errors.is_veteran_unemployed_6_months && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.is_veteran_unemployed_6_months as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you a veteran entitled to compensation for a service-connected disability who was discharged or released from active duty in the U.S. Armed Forces during the past year*'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Are you a veteran entitled to compensation for a service-connected disability who was discharged or released from active duty in the U.S. Armed Forces during the past year"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.is_veteran_disability_discharged_past_year
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('is_veteran_disability_discharged_past_year', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.is_veteran_disability_discharged_past_year &&
                                            props.errors.is_veteran_disability_discharged_past_year && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.is_veteran_disability_discharged_past_year as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you a veteran entitled to compensation for a service-connected disability who has been unemployed for a total of at least 6 months during the past year?*'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Are you a veteran entitled to compensation for a service-connected disability who has been unemployed for a total of at least 6 months during the past year?"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.is_veteran_disability_unemployed_6_months
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('is_veteran_disability_unemployed_6_months', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.is_veteran_disability_unemployed_6_months &&
                                            props.errors.is_veteran_disability_unemployed_6_months && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.is_veteran_disability_unemployed_6_months as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>


                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'select any of the options that apply to you.?*'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="select any of the options that apply to you.?"
                                            options={options3}
                                            selectedOption={mapSelectValue(
                                                options3,
                                                props.values.is_family_tanf_eligible
                                            )}
                                            onSelect={(option: any) => {
                                                console.log("is_family_tanf_eligible", option)
                                                if (option == 4) {
                                                    props.setFieldValue('is_family_tanf_eligible', 0)
                                                }
                                                else {
                                                    props.setFieldValue('is_family_tanf_eligible', 1)
                                                }
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.is_family_tanf_eligible &&
                                            props.errors.is_family_tanf_eligible && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.is_family_tanf_eligible as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View
                                        style={{
                                            justifyContent: 'center',
                                            width: '50%',
                                            overflow: 'hidden'
                                        }}
                                    >
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you in a period of unemployment that is at least 27 consecutive weeks, and did you receive unemployment compensation for all or part of that period?*'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '28%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Are you in a period of unemployment that is at least 27 consecutive weeks, and did you receive unemployment compensation for all or part of that period?"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.is_unemployed_27_weeks
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('is_unemployed_27_weeks', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.is_unemployed_27_weeks &&
                                            props.errors.is_unemployed_27_weeks && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.is_unemployed_27_weeks as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>



                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </>
                    )}
                </Formik>
            </View>
        </KeyboardAwareScrollView>
    )
}
export default Form8850InformationForm
